module.exports = __webpack_public_path__ + "1_0_64/img/unlink.d0b94eef.svg";